<template>
  <div class="tw-rounded-2xl tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-3">
      <h3 class="tw-flex tw-items-center tw-gap-2 tw-text-base tw-font-semibold tw-text-slate-900">
        <font-awesome-icon icon="sticky-note" class="tw-h-4 tw-w-4 tw-text-slate-500" />
        <span>{{ baseLoadText }}s</span>
      </h3>

      <div class="tw-flex tw-items-center tw-gap-2">
        <Button
          v-if="order.status != 'Complete' && editable && isLandOrder(order)"
          @click="addNewFreightContent"
        >Add Freight Content</Button>
        <Button
          v-else-if="order.status != 'Complete' && editable"
          @click="addNewContainer"
        >Add Container</Button>
      </div>
    </div>

    <div class="tw-p-3 sm:tw-p-4">
      <div v-if="isLoadingContainersQuery" class="tw-flex tw-items-center tw-justify-center tw-py-10">
        <div class="tw-h-7 tw-w-7 tw-animate-spin tw-rounded-full tw-border-2 tw-border-slate-300 tw-border-t-slate-600"></div>
      </div>
      <div v-else class="tw-overflow-x-auto tw-overflow-y-visible">
      <OrderCancelContainerModal
        v-model:isOpen="isCancelContainerModalOpen"
        :containerLabel="cancelContainerTarget?.containerId"
        @cancel="closeCancelContainerModal"
        @submit="submitCancelContainer"
      />
      <OrderEditContainerDetailsModal
        v-if="!isLandOrder(order)"
        v-model:isOpen="isEditContainerDetailsModalOpen"
        :model="editContainerDetailsModel"
        :isSaving="isEditContainerDetailsSaving"
        :isExportOrder="isOceanExport(order)"
        @cancel="closeEditContainerDetailsModal"
        @save="saveEditContainerDetails"
      />

      <OrderAddContainerModal
        v-if="!isLandOrder(order)"
        v-model:isOpen="isAddContainerModalOpen"
        :model="containerAddition"
        :isSaving="containerAddition.isLoading"
        :is-export-order="isOceanExport(order)"
        @cancel="cancelContainerAddition"
        @save="confirmContainerAddition(order)"
      />

      <table
        class="tw-min-w-[1100px] tw-w-full tw-text-left tw-text-sm tw-leading-5"
        v-if="!isLandOrder(order)"
      >
        <thead>
          <template v-if="shouldShowContainerInfo">
            <tr class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4">Container Number</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4">Size Type</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4">Seal Number</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4">Cargo Pieces</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4">Cargo Description</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4">Weight</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4" v-if="shouldShowYardStatus">Yard Status</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4" v-if="shouldShowPickUpNumber">Pick-Up #</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4" v-if="shouldShowReleaseNumber">Release #</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4" v-if="shouldShowEtaOrLfd">ETA/LFD</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4">EIR/Appt</th>
              <th class="tw-whitespace-nowrap tw-p-0.5 tw-pr-4">Status</th>
              <th class="tw-px-3 tw-py-2"></th>
            </tr>
          </template>
          <!-- <template v-else>
            <th class="uk-text-nowrap">Freight Content</th>
            <th>Quantity</th>
            <th>Cargo Description</th>
            <th>Weight</th>
            <th class="uk-table-expand">Status</th>
            <th></th>
          </template> -->
        </thead>

        <tbody
          v-for="(container, containerIdx) in containersWithTrips"
          :key="container.id"
        >
          <tr
            @click="toggleTripStatusSingleContainer(container.id)"
            v-if="
              showTripForContainerIdx == container.id ||
              showTripForContainerIdx == -1
            "
            class="container-item-row tw-cursor-pointer tw-border-t tw-border-slate-200/70 hover:tw-bg-slate-900/5"
            v-bind:class="{
              'clr-storm-6':
                showTripForContainerIdx == container.id ||
                showContainerHistoryIdx == container.id,
              'tall-row':
                showTripForContainerIdx == container.id ||
                showContainerHistoryIdx == container.id,
              'tw-bg-amber-100/70': lastOpenedContainerIdx == container.id,
            }"
          >
            <td
              v-if="isEditingContainerNumber == container.id"
              @click.prevent.stop
              class="tw-px-3 tw-py-2"
            >
              <div class="tw-whitespace-nowrap">
              <input
                class="tw-w-56 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="editingContainerNumber"
              />
              <Button
                @click="saveContainerNumber(container)"
                :disabled="isContainerEditingNumberInvalid"
                :isGray="isContainerEditingNumberInvalid"
                :isGreen="!isContainerEditingNumberInvalid"
                class="tw-ml-2 tw-h-9 tw-w-9 tw-p-0"
                icon="check"
                title="Save container number"
                aria-label="Save container number"
              />
              <Button
                @click="cancelContainerNumberEdit"
                :isRed="true"
                class="tw-ml-1 tw-h-9 tw-w-9 tw-p-0"
                icon="xmark"
                title="Cancel container number edit"
                aria-label="Cancel container number edit"
              />
              </div>
            </td>
            <td v-else class="tw-px-3 tw-py-2 tw-text-slate-900">
              <div class="tw-whitespace-nowrap">
              <button
                type="button"
                class="tw-mr-1 tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-500 hover:tw-bg-white/60 hover:tw-text-slate-700 focus:tw-outline-none"
                @click.prevent.stop="toggleContainerHistory(container.id)"
                :aria-label="(showContainerHistoryIdx == container.id || showTripForContainerIdx == container.id) ? 'Collapse' : 'Expand'"
              >
                <font-awesome-icon
                  icon="chevron-down"
                  class="tw-h-3.5 tw-w-3.5 tw-transition-transform"
                  :class="{
                    'tw-rotate-0': showTripForContainerIdx == container.id || showContainerHistoryIdx == container.id,
                    '-tw-rotate-90': !(showTripForContainerIdx == container.id || showContainerHistoryIdx == container.id),
                  }"
                />
              </button>
              <span class="tw-inline-flex tw-items-center tw-gap-2" @click.prevent.stop>
                <strong>
                  {{ order.id }}-{{ pad(container.internalIndex || containerIdx + 1, 2) }}-<template v-if="!container.containerId || container.containerId === 'EXPUNDEF'">
                    (not set)
                    </template><template v-else>
                      <CopyButton
                        :value="container.containerId"
                        mode="wrap-content"
                        title="Copy container number"
                        aria-label="Copy container number"
                      >
                        {{  container.containerId }}
                      </CopyButton>
                    </template>
                </strong>
                <span
                  v-if="container.isCancelled"
                  class="tw-ml-2 tw-inline-flex tw-items-center tw-rounded-md tw-bg-rose-50 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-rose-800 tw-ring-1 tw-ring-inset tw-ring-rose-600/20"
                  :title="container.cancelledReason || 'Cancelled'"
                >
                  Cancelled
                </span>
                &nbsp;
                <button
                  v-if="editable && !container.isCancelled"
                  type="button"
                  class="tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-500 hover:tw-bg-white/60 hover:tw-text-slate-700 focus:tw-outline-none"
                  @click.prevent.stop="addContainerNumber(container)"
                  aria-label="Edit container number"
                  title="Edit container number"
                >
                  <font-awesome-icon icon="pen" class="tw-h-3.5 tw-w-3.5" />
                </button>
              </span>
              </div>
            </td>

            <td v-if="shouldShowContainerInfo">
              {{ container.sizeType }}
              
              <span v-if="container.isGensetRequired" class="tw-mx-1"
                v-tippy="{ content: container.isGensetApprovedByShipline === true ? 'Genset needed, approved' : 'Genset needed, NOT approved yet', placement: 'top' }">
                <font-awesome-icon icon="bolt-lightning" class="tw-h-3 tw-w-3"
                  :class="container.isGensetApprovedByShipline === true ? 'tw-text-emerald-400' : 'tw-text-slate-500'" />
              </span>
              <span v-if="getHasGensetTemperatureOrVents(container)" class=""
                v-tippy="{ content: getGensetTemperatureAndVentsTooltip(container), placement: 'bottom' }">
                <font-awesome-icon icon="temperature-high" class="tw-h-3 tw-w-3 tw-text-slate-500" />
              </span>
            </td>
            <td>{{ container.sealNumber }}</td>
            <td>{{ container.freightContents[0].cargoPieces }}</td>

            <td>{{ cargoDescriptionString(container) }}</td>
            <td>
              {{ containerWeight(container.freightContents[0].weight) }}
            </td>
            <td v-if="shouldShowYardStatus">
              <div
                v-if="container.isCancelled"
                class="tw-text-sm tw-text-rose-800"
                :title="container.cancelledReason || undefined"
              >
                Cancelled<span v-if="container.cancelledReason"> — {{ container.cancelledReason }}</span>
              </div>
              <YardStatusLabel
                v-else-if="container.isActive || !editable"
                :container="container"
              ></YardStatusLabel>
              <div v-else>Container Archived</div>
            </td>
            <td v-if="shouldShowPickUpNumber">{{ container.pickupNumber }}</td>
            <td v-if="shouldShowReleaseNumber">
              {{ container.releaseNumber }}
            </td>
            <td v-if="shouldShowEtaOrLfd" class="tw-whitespace-nowrap">
              <template v-if="getIsEtaShownForYardStatus(container.yardStatus)">ETA {{ container.eta }}</template>
              <template v-else-if="container.lfd && container.lfd.length > 2">LFD {{ container.lfd }}</template>
              <template v-else>No LFD</template>
            </td>
            <td>
              <p v-if="container.eirInDate">
                EIR In: {{ formatDate(container.eirInDate) }}
              </p>
              <p v-if="container.eirOutDate">
                EIR Out: {{ formatDate(container.eirOutDate) }}
              </p>
              <p v-if="container.terminalAppointmentDate">
                Term Appt:
                {{ formatAppointmentDatetime(container.terminalAppointmentDate, container.terminalAppointmentHasTime) }}
              </p>
              <p v-if="container.deliveryAppointmentDate">
                {{ isOceanExport(order) ? 'Pick-Up Appt' : 'Deliv Appt' }}:
                {{ formatAppointmentDatetime(container.deliveryAppointmentDate, container.deliveryAppointmentHasTime) }}
              </p>
              <p v-if="container.returnTerminalAppointmentDate || getIsReturningToDifferentLocation(container.terminal, container.returnLocation)">
                Return Term Appt:
                <template v-if="container.returnTerminalAppointmentDate">
                  {{ formatAppointmentDatetime(container.returnTerminalAppointmentDate, container.returnTerminalAppointmentHasTime) }}
                </template>
              </p>
              <p
                v-if="getIsReturningToDifferentLocation(container.terminal, container.returnLocation)"
                v-tippy="container.returnLocation.name+', '+container.returnLocation.address.address"
                class="tw-whitespace-nowrap tw-font-medium tw-text-slate-800 tw-p-0.5 tw-border-2 tw-border-dotted tw-border-red-500 tw-w-auto tw-overflow-clip "
              >
                Return to:
                <span
                  :class="getTerminalColorClassForLocation(container.returnLocation)">* {{ getLocationDisplayName(container.returnLocation) }}</span>
              </p>
            </td>
            <td>
              <Badge
                v-if="container.isCancelled"
                :isRed="true"
                >Cancelled</Badge
              >
              <Badge
                v-else
                :isGreen="tripCompletionText(container.trips) == 'In Progress'"
                :isOrange="tripCompletionText(container.trips) == 'Complete'"
                >{{ tripCompletionText(container.trips) }}</Badge
              >
            </td>
            <td v-on:click.stop>
              <div class="tw-flex tw-justify-center">
                <OrderContainerDropdown
                  v-if="editable"
                  @showContainer="showContainer"
                  @editContainerDetails="editContainerDetails"
                  @toggleTripStatus="toggleTripStatus"
                  @addContainerNumber="addContainerNumber"
                  @addEmptyTrip="addEmptyTrip"
                  @cancelContainer="openCancelContainerModal"
                  @uncancelContainer="uncancelContainer"
                  :order="order"
                  :container="container"
                  :containerIdx="containerIdx"
                ></OrderContainerDropdown>
              </div>
            </td>
          </tr>

          <tr
            v-if="showContainerHistoryIdx == container.id"
            class="tw-border-t tw-border-slate-200/70"
          >
            <td :colspan="99" class="tw-px-3 tw-py-4" @click.stop>
              <div
                v-if="!container?.trips || container.trips.length === 0"
                class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-4 tw-py-6 tw-text-center"
              >
                <div class="tw-text-sm tw-font-semibold tw-text-slate-900">No data</div>
                <div class="tw-mt-1 tw-text-sm tw-text-slate-600">No trips are available for this container yet.</div>
              </div>
              <div v-else class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-p-4">
                <OrderContainerDetails
                  :chassis="chassis"
                  :drivers="drivers"
                  :order="order"
                  :editable="editable && !container.isCancelled"
                  :containerId="container.id"
                >
                </OrderContainerDetails>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Land order -->
      <table
        class="tw-min-w-[900px] tw-w-full tw-text-left tw-text-sm tw-leading-5"
        v-else
      >
        <thead>
          <tr class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">
            <th class="tw-whitespace-nowrap tw-px-3 tw-py-2">Quantity</th>
            <th class="tw-whitespace-nowrap tw-px-3 tw-py-2">Package Type</th>
            <th class="tw-whitespace-nowrap tw-px-3 tw-py-2">Is Hazmat</th>
            <th class="tw-whitespace-nowrap tw-px-3 tw-py-2">Weight (lbs)</th>
            <th class="tw-whitespace-nowrap tw-px-3 tw-py-2">Description</th>
            <th class="tw-whitespace-nowrap tw-px-3 tw-py-2">NMFC #</th>
            <th class="tw-whitespace-nowrap tw-px-3 tw-py-2">NMFC Class</th>
            <th class="tw-px-3 tw-py-2"></th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-if="
              (showTripForContainerIdx == containersWithTrips[0].id ||
                showTripForContainerIdx == -1) &&
              addingFreightContent
            "
            v-bind:class="{
              'clr-storm-6':
                showTripForContainerIdx == containersWithTrips[0].id ||
                showContainerHistoryIdx == containersWithTrips[0].id,
              'tall-row':
                showTripForContainerIdx == containersWithTrips[0].id ||
                showContainerHistoryIdx == containersWithTrips[0].id,
            }"
          >
            <td class="tw-px-3 tw-py-2" @click.prevent.stop>
              <input
                class="tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContentAddition.quantity"
              />
            </td>
            <td class="tw-px-3 tw-py-2" @click.prevent.stop>
              <input
                class="tw-w-44 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContentAddition.packingType"
              />
            </td>
            <td class="tw-px-3 tw-py-2">
              <InputField
                type="checkbox"
                v-model="freightContentAddition.isHazmat"
                id="IsHazmat"
              ></InputField>
            </td>
            <td class="tw-px-3 tw-py-2" @click.prevent.stop>
              <input
                class="tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContentAddition.weight"
              />
            </td>
            <td class="tw-px-3 tw-py-2" @click.prevent.stop>
              <input
                class="tw-w-64 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContentAddition.description"
              />
            </td>
            <td class="tw-px-3 tw-py-2" @click.prevent.stop>
              <input
                class="tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContentAddition.nmfcNumber"
              />
            </td>
            <td class="tw-px-3 tw-py-2" @click.prevent.stop>
              <input
                class="tw-w-32 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContentAddition.nmfcClass"
              />
            </td>
            <td class="tw-px-3 tw-py-2" v-on:click.stop>
              <Button
                @click="saveNewFreightContent()"
                >Save</Button
              >
              <Button
                @click="cancelFreightContentAdd()"
                class="tw-ml-2"
                :isGray="true"
                >Cancel</Button
              >
            </td>
          </tr>
          <tr
            v-for="(freightContent, freightContentIdx) in containersWithTrips[0]
              .freightContents"
            :key="freightContent.id"
            v-bind:class="{
              'clr-storm-6':
                showTripForContainerIdx == containersWithTrips[0].id ||
                showContainerHistoryIdx == containersWithTrips[0].id,
              'tall-row':
                showTripForContainerIdx == containersWithTrips[0].id ||
                showContainerHistoryIdx == containersWithTrips[0].id,
            }"
          >
            <td
              v-if="editingFreightContentIdx == freightContentIdx"
              @click.prevent.stop
              class="tw-px-3 tw-py-2"
            >
              <input
                class="tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContent.cargoPieces"
              />
            </td>
            <td
              v-else
              class="tw-px-3 tw-py-2 tw-text-slate-900"
              @click="toggleTripStatus(containersWithTrips[0].id)"
            >
              <p>{{ freightContent.cargoPieces }}</p>
            </td>
            <td
              v-if="editingFreightContentIdx == freightContentIdx"
              @click.prevent.stop
              class="tw-px-3 tw-py-2"
            >
              <input
                class="tw-w-44 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContent.packingType"
              />
            </td>
            <td
              v-else
              class="tw-px-3 tw-py-2 tw-text-slate-900"
              @click="toggleTripStatus(containersWithTrips[0].id)"
            >
              <p>{{ freightContent.packingType }}</p>
            </td>
            <td v-if="editingFreightContentIdx == freightContentIdx" class="tw-px-3 tw-py-2">
              <InputField
                type="checkbox"
                v-model="freightContent.isHazmat"
                id="IsHazmat2"
              ></InputField>
            </td>
            <td
              v-else
              class="tw-px-3 tw-py-2 tw-text-slate-900"
              @click="toggleTripStatus(containersWithTrips[0].id)"
            >
              <p>{{ freightContent.isHazmat }}</p>
            </td>
            <td
              v-if="editingFreightContentIdx == freightContentIdx"
              @click.prevent.stop
              class="tw-px-3 tw-py-2"
            >
              <input
                class="tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContent.weight"
              />
            </td>
            <td
              v-else
              class="tw-px-3 tw-py-2 tw-text-slate-900"
              @click="toggleTripStatus(containersWithTrips[0].id)"
            >
              <p>{{ containerWeight(freightContent.weight) }}</p>
            </td>
            <td
              v-if="editingFreightContentIdx == freightContentIdx"
              @click.prevent.stop
              class="tw-px-3 tw-py-2"
            >
              <input
                class="tw-w-64 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContent.cargoDescription"
              />
            </td>
            <td
              v-else
              class="tw-px-3 tw-py-2 tw-text-slate-900"
              @click="toggleTripStatus(containersWithTrips[0].id)"
            >
              <p>{{ freightContent.cargoDescription }}</p>
            </td>
            <td
              v-if="editingFreightContentIdx == freightContentIdx"
              @click.prevent.stop
              class="tw-px-3 tw-py-2"
            >
              <input
                class="tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContent.nmfcNumber"
              />
            </td>
            <td
              v-else
              class="tw-px-3 tw-py-2 tw-text-slate-900"
              @click="toggleTripStatus(containersWithTrips[0].id)"
            >
              <p>{{ freightContent.nmfcNumber }}</p>
            </td>
            <td
              v-if="editingFreightContentIdx == freightContentIdx"
              @click.prevent.stop
              class="tw-px-3 tw-py-2"
            >
              <input
                class="tw-w-32 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
                type="text"
                v-model="freightContent.nmfcClass"
              />
            </td>
            <td
              v-else
              class="tw-px-3 tw-py-2 tw-text-slate-900"
              @click="toggleTripStatus(containersWithTrips[0].id)"
            >
              <p>{{ freightContent.nmfcClass }}</p>
            </td>
            <td
              v-on:click.stop
              v-if="editingFreightContentIdx === freightContentIdx"
              class="tw-px-3 tw-py-2"
            >
              <Button
                @click="saveFreightContent(freightContent)"
                >Save</Button
              >
              <Button
                @click="cancelFreightContentEdit()"
                class="tw-ml-2"
                :isGray="true"
                >Cancel</Button
              >
            </td>
            <td v-else v-on:click.stop>
              <div class="tw-flex tw-justify-center">
                <OrderContainerDropdown
                  v-if="editable"
                  @showContainer="showContainer"
                  @editContainerDetails="editContainerDetails"
                  @editFreightContent="editFreightContent"
                  @toggleTripStatus="toggleTripStatus"
                  @addContainerNumber="addContainerNumber"
                  @addEmptyTrip="addEmptyTrip"
                  @cancelContainer="openCancelContainerModal"
                  @uncancelContainer="uncancelContainer"
                  :isLand="isLandOrder(order)"
                  :order="order"
                  :freightContent="freightContent"
                  :freightContentIdx="freightContentIdx"
                  :container="containersWithTrips[0]"
                  :containerIdx="containersWithTrips[0].id"
                ></OrderContainerDropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';

import EditCargoPieces from '@/gql/orders/mutations/EditCargoPieces.gql';
import EditWeight from '@/gql/orders/mutations/EditWeight.gql';
import DatePicker from '@/components/core/DateTime/DatePicker.vue';

import EditFreightContent from '@/gql/containers/mutations/EditFreightContent.gql';
import AddFreightContent from '@/gql/containers/mutations/AddFreightContent.gql';

import EditSealNumberMutation from '@/gql/orders/mutations/EditSealNumber.gql';
import EditTripDestination from '@/gql/orders/trips/mutations/EditTripDestination.gql';
import EditTripDriver from '@/gql/orders/trips/mutations/EditTripDriver.gql';
import EditTripOrigin from '@/gql/orders/trips/mutations/EditTripOrigin.gql';
import EditTripStatus from '@/gql/orders/trips/mutations/EditTripStatus.gql';
import AddTripMutation from '@/gql/dispatch/AddTrip.gql';
import Badge from '@/components/core/Badge.vue';
import AddContainer from '@/gql/orders/mutations/AddContainer.gql';
import AddDefaultTripsMutation from '@/gql/orders/trips/mutations/AddDefaultTrips.gql';

import YardStatusLabel from '@/components/UI/YardStatusLabel.vue';
import EditTripChassis from '@/gql/orders/trips/mutations/EditTripChassis.gql';
import EditTripType from '@/gql/orders/trips/mutations/EditTripType.gql';
import EditTripMutation from '@/gql/dispatch/EditTrip.gql';

import FilterableDropdown from '@/components/core/FilterableDropdown.vue';

import OrderAddContainerModal from './OrderAddContainerModal.vue';
import OrderEditContainerDetailsModal, { type EditContainerDetailsModel } from './OrderEditContainerDetailsModal.vue';

import OrderContainerDropdown from './OrderContainerDropdown.vue';
import OrderCancelContainerModal from './OrderCancelContainerModal.vue';
import CancelOrderContainerMutation from '@/gql/orders/mutations/CancelOrderContainer.gql';
import UncancelOrderContainerMutation from '@/gql/orders/mutations/UncancelOrderContainer.gql';
import UpdateContainerNumber from '../../../gql/orders/mutations/UpdateContainerNumber.gql';
import EditContainer from '../../../gql/orders/mutations/EditContainer.gql';
import BaseDateTimePicker from '../../core/DateTime/BaseDateTimePicker.vue';

import InputField from '../../core/Input/InputField.vue';
import { type Order, type Container, TRIP_STATUS } from '../../../types';

import isContainer from '../../../utils/container_validator';
import Button from '../../core/Button.vue';

import { dateFormatMixin, datetimeFormatMixin } from '../../../utils/date';
import { orderTypeMethodsMixin } from '../../../utils/order';
import OrderContainerDetails from './OrderContainerDetails.vue';
import { pushToast } from '@/lib/toast';
import CopyButton from '../../core/CopyButton.vue';
import {
  getIsReturningToDifferentLocation, getLocationDisplayName, getTerminalColorClassForLocation,
  getHasGensetTemperatureOrVents, getGensetTemperatureAndVentsTooltip, getIsEtaShownForYardStatus,
} from '@/utils/container';

export default defineComponent({
  components: {
    Button,
    OrderContainerDropdown,
    OrderCancelContainerModal,
    Badge,
    YardStatusLabel,
    FilterableDropdown,
    OrderAddContainerModal,
    OrderEditContainerDetailsModal,
    DatePicker,
    BaseDateTimePicker,
    // InputField,
    OrderContainerDetails,
    CopyButton,
  },
  mixins: [dateFormatMixin, datetimeFormatMixin, orderTypeMethodsMixin],
  data() {
    return {
      addTripLoading: false,
      isEditingSealNumber: -1,
      isEditingCargoPieces: -1,
      isEditingCargoDescription: -1,
      isEditingContainerNumber: -1,
      isEditingWeight: -1,
      showTripForContainerIdx: -1,
      showContainerHistoryIdx: -1,
      // Kept only while this table is mounted (not persisted like the list pages)
      lastOpenedContainerIdx: -1,
      editingWeight: undefined,
      editingSealNumber: undefined,
      editingCargoPieces: undefined,
      editingContainerNumber: undefined,
      isEditContainerDetailsModalOpen: false,
      isEditContainerDetailsSaving: false,
      editContainerDetailsModel: null as EditContainerDetailsModel | null,
      editingFreightContentIdx: -1,
      addingFreightContent: false,

      // trips
      tripAdditionContainer: undefined,
      isAddContainerModalOpen: false,
      containerAddition: {
        isLoading: false,
        containerId: undefined,
        containerSize: undefined,
        containerType: undefined,
        cargoPieces: undefined,
        weight: undefined,
        cargoDescription: undefined,
        sealNumber: undefined,
      },
      freightContentAddition: {
        quantity: undefined,
        packingType: undefined,
        isHazmat: false,
        weight: undefined,
        description: undefined,
        nmfcNumber: undefined,
        nmfcClass: undefined,
      },
      isCancelContainerModalOpen: false,
      cancelContainerTarget: null as Container | null,
    };
  },
  props: {
    order: {
      type: Object as PropType<Order>,
      required: true,
    },
    containersWithTrips: {
      type: Array as PropType<Container[]>,
      default: () => [],
    },
    isLoadingContainersQuery: {
      type: Boolean,
      default: false,
    },
    editable: {
      default: true,
    },
    showDriver: {
      default: true,
    },
    drivers: {
      type: Array as PropType<any[]>,
      required: true,
    },
    chassis: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  watch: {
    containersWithTrips: {
      immediate: true,
      handler() {
        (this as any).expandTripsForSingleContainer();
      },
    },
  },
  methods: {
    getIsReturningToDifferentLocation,
    getLocationDisplayName,
    getTerminalColorClassForLocation,
    getHasGensetTemperatureOrVents,
    getGensetTemperatureAndVentsTooltip,
    getIsEtaShownForYardStatus,
    expandTripsForSingleContainer() {
      const vm = (this as any);
      if (!Array.isArray(vm.containersWithTrips)) return;
      if (vm.containersWithTrips.length !== 1) return;

      const onlyContainer = vm.containersWithTrips[0];
      if (!onlyContainer?.id) return;

      vm.showTripForContainerIdx = onlyContainer.id;
      vm.showContainerHistoryIdx = onlyContainer.id;
    },
    pad(num, size) {
      num = num.toString();
      while (num.length < size) num = '0' + num;
      return num;
    },
    isLandOrder(order: any) {
      if (order.orderType === 'Land') {
        return true;
      } else {
        return false;
      }
    },
    editCargoPieces(containerIdx: any) {
      (this as any).isEditingCargoPieces = containerIdx;
    },
    cancelEditCargoPieces() {
      (this as any).isEditingCargoPieces = -1;
    },
    saveCargoPieces(id: string) {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: EditCargoPieces,
          variables: {
            containerId: id,
            cargoPieces: vm.editingCargoPieces,
          },
        })
        .then((data) => {
          vm.isEditingSealNumber = -1;
          vm.editingSealNumber = undefined;
          vm.editingWeight = undefined;
          vm.editingCargoPieces = undefined;
          vm.isEditingCargoDescription = -1;
          vm.isEditingCargoPieces = -1;
          vm.isEditingWeight = -1;
          // this.$apollo.queries.order.refetch();
        })
        .catch((err) => {
          vm.isEditingSealNumber = -1;
          vm.editingSealNumber = undefined;
          vm.editingWeight = undefined;
          vm.editingCargoPieces = undefined;
          vm.isEditingCargoDescription = -1;
          vm.isEditingCargoPieces = -1;
          vm.isEditingWeight = -1;
        });
    },
    editSealNumber(containerIdx: any) {
      (this as any).isEditingSealNumber = containerIdx;
    },
    cancelSealNumberEdit() {
      (this as any).isEditingSealNumber = -1;
    },
    saveSealNumber(id: string) {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: EditSealNumberMutation,
          variables: {
            containerId: id,
            sealNumber: vm.editingSealNumber,
          },
        })
        .then((data) => {
          vm.isEditingSealNumber = -1;
          vm.editingSealNumber = undefined;
          vm.editingWeight = undefined;
          vm.editingCargoPieces = undefined;
          vm.isEditingCargoDescription = -1;
          vm.isEditingCargoPieces = -1;
          vm.isEditingWeight = -1;
          vm.$apollo.queries.order.refetch();
        })
        .catch((err) => {
          vm.isEditingSealNumber = -1;
          vm.editingSealNumber = undefined;
          vm.editingWeight = undefined;
          vm.editingCargoPieces = undefined;
          vm.isEditingCargoDescription = -1;
          vm.isEditingCargoPieces = -1;
          vm.isEditingWeight = -1;
        });
    },
    changedContainerEIRIn(dateStr: string, container: Container) {
      const parsedDate = (this as any).formatDate(dateStr);
      container.eirIn = parsedDate;
    },
    changedContainerEIROut(dateStr: string, container: Container) {
      const parsedDate = (this as any).formatDate(dateStr);
      container.eirOut = parsedDate;
    },
    cancelContainerAddition() {
      const vm = (this as any);

      vm.isAddContainerModalOpen = false;
      vm.containerAddition = {
        isLoading: false,
        containerId: undefined,
        containerSize: undefined,
        containerType: undefined,
        cargoPieces: undefined,
        weight: undefined,
        cargoDescription: undefined,
        sealNumber: undefined,
      };
    },
    cancelFreightContentAdd() {
      const vm = (this as any);

      vm.addingFreightContent = false;
    },
    cancelFreightContentEdit() {
      const vm = (this as any);

      vm.editingFreightContentIdx = -1;
    },
    refreshOrders() {
      const vm = (this as any);

      vm.$emit('refreshOrders');
    },
    containerWeight(weight: any): string {
      let weightNumber;
      if (!weight) {
        return undefined;
      }
      if (isNaN(weight)) {
        if (weight.includes('lbs')) {
          weightNumber = Number(weight.replace('lbs', ''));
        } else if (weight.includes('lb')) {
          weightNumber = Number(weight.replace('lb', ''));
        } else {
          return weight;
        }
      } else {
        weightNumber = weight;
      }

      const formatterWeight = `${Number(weightNumber).toLocaleString()} lbs`;
      return formatterWeight;
    },
    addNewFreightContent() {
      const vm = (this as any);

      vm.addingFreightContent = true;
    },
    addNewContainer() {
      const vm = (this as any);
      vm.isAddContainerModalOpen = true;
    },
    updateContainers() {
      (this as any).$emit('updateContainers');
    },
    confirmContainerAddition(order) {
      const vm = (this as any);
      const orderId = Number(vm.order?.id);
      const rawContainerId = String(vm.containerAddition.containerId || '').trim();
      const containerId =
        rawContainerId.length > 0
          ? rawContainerId
          : vm.isOceanExport(order)
            ? null
            : undefined;

      vm.containerAddition.isLoading = true;
      vm.$apollo
        .mutate({
          mutation: AddContainer,
          variables: {
            orderId,
            containerId,
            containerSize: vm.containerAddition.containerSize,
            containerType: vm.containerAddition.containerType,
            cargoPieces: vm.containerAddition.cargoPieces,
            weight: vm.containerAddition.weight,
            sealNumber: vm.containerAddition.sealNumber,
            cargoDescription: vm.containerAddition.cargoDescription,
          },
        })
        .then((data) => {
          (this as any).$emit('updateContainers');
          vm.containerAddition.isLoading = false;
          vm.isAddContainerModalOpen = false;
          vm.containerAddition = {
            isLoading: false,
            containerId: undefined,
            containerSize: undefined,
            containerType: undefined,
            cargoPieces: undefined,
            weight: undefined,
            cargoDescription: undefined,
            sealNumber: undefined,
          };
        })
        .catch((err) => {
          const gqlMessage =
            err?.graphQLErrors?.[0]?.message ||
            err?.networkError?.result?.errors?.[0]?.message ||
            err?.message;
          const message =
            gqlMessage && gqlMessage.trim().length > 0
              ? gqlMessage
              : 'Unable to add container. Please verify that the container is not already assigned to another order.';
          pushToast(message, 'error');
          console.error(`Error while added new container ${err}`);
          vm.containerAddition.isLoading = false;
        });
    },
    saveNewFreightContent() {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: AddFreightContent,
          variables: {
            containerLoadId: vm.containersWithTrips[0].id,
            freightContent: vm.freightContentAddition,
          },
        })
        .then(() => {
          vm.addingFreightContent = false;
          vm.freightContentAddition = {
            quantity: undefined,
            packingType: undefined,
            isHazmat: false,
            weight: undefined,
            description: undefined,
            nmfcNumber: undefined,
            nmfcClass: undefined,
          };
        })
        .catch((err) => {
          console.error(err);
        });
    },
    saveFreightContent(freightContent) {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: EditFreightContent,
          variables: {
            id: freightContent.id,
            freightContent: {
              quantity: freightContent.cargoPieces,
              packingType: freightContent.packingType,
              weight: freightContent.weight,
              description: freightContent.cargoDescription,
              isHazmat: freightContent.isHazmat,
              nmfcNumber: freightContent.nmfcNumber,
              nmfcClass: freightContent.nmfcClass,
            },
          },
        })
        .then(() => {
          vm.editingFreightContentIdx = -1;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    editContainerDetails(containerIdx) {
      const vm = (this as any);

      const container = (vm.containersWithTrips || [])[containerIdx];
      if (!container) return;

      const formatToUI = (dateStr: string | null | undefined) => {
        if (!dateStr) return undefined;
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return undefined;

        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
      };

      vm.editContainerDetailsModel = {
        id: container.id,
        containerId: container.containerId,
        internalIndex: container.internalIndex,
        sizeType: container.sizeType,
        sealNumber: container.sealNumber,
        cargoPieces: container.freightContents?.[0]?.cargoPieces,
        cargoDescription: container.freightContents?.[0]?.cargoDescription,
        weight: container.freightContents?.[0]?.weight,
        referenceNumber: container.referenceNumber,
        eirIn: formatToUI(container.eirInDate),
        eirOut: formatToUI(container.eirOutDate),
        terminalAppointmentDate: formatToUI(container.terminalAppointmentDate),
        terminalAppointmentHasTime: container.terminalAppointmentHasTime ?? true,
        deliveryAppointmentDate: formatToUI(container.deliveryAppointmentDate),
        deliveryAppointmentHasTime: container.deliveryAppointmentHasTime ?? true,
        isReturningToAnotherLocation: getIsReturningToDifferentLocation(container.terminal, container.returnLocation),
        returnLocation: container.returnLocation ?? null,
        returnTerminalAppointmentDate: formatToUI(container.returnTerminalAppointmentDate),
        returnTerminalAppointmentHasTime: container.returnTerminalAppointmentHasTime ?? true,
      };
      vm.isEditContainerDetailsModalOpen = true;
    },
    closeEditContainerDetailsModal() {
      const vm = (this as any);
      vm.isEditContainerDetailsModalOpen = false;
      vm.editContainerDetailsModel = null;
    },
    saveEditContainerDetails(model: EditContainerDetailsModel) {
      const vm = (this as any);
      if (!model || !model.id) return;
      vm.isEditContainerDetailsSaving = true;
      vm.$apollo
        .mutate({
          mutation: EditContainer,
          variables: {
            id: model.id,
            sizeType: model.sizeType,
            sealNumber: model.sealNumber,
            cargoPieces: model.cargoPieces,
            cargoDescription: model.cargoDescription,
            weight: model.weight,
            referenceNumber: model.referenceNumber,
            eirIn: model.eirIn || '', // explicitly send empty strings to denote intention to "clear out value in backend/db"
            eirOut: model.eirOut || '', 
            terminalAppointmentDate: model.terminalAppointmentDate || '',
            terminalAppointmentHasTime: model.terminalAppointmentHasTime,
            deliveryAppointmentDate: model.deliveryAppointmentDate || '',
            deliveryAppointmentHasTime: model.deliveryAppointmentHasTime,
            returnLocationId: (model.isReturningToAnotherLocation && model.returnLocation?.id) || '', // '' clears it
            returnTerminalAppointmentDate: model.returnTerminalAppointmentDate || '',
            returnTerminalAppointmentHasTime: model.returnTerminalAppointmentHasTime,
          },
        })
        .then(() => {
          vm.isEditContainerDetailsSaving = false;
          vm.closeEditContainerDetailsModal();
          vm.$emit('refreshOrders');
        })
        .catch((err) => {
          console.error(err);
          vm.isEditContainerDetailsSaving = false;
        });
    },
    editFreightContent(freightContentIdx) {
      const vm = (this as any);

      vm.editingFreightContentIdx = freightContentIdx;
    },
    showContainer(container: Container) {
      const vm = (this as any);

      vm.$emit('showContainer', container);
    },
    toggleTripStatus(containerIdx) {
      const vm = (this as any);

      vm.$emit('showContainerDetails', containerIdx);
    },
    toggleTripStatusSingleContainer(containerIdx) {
      const vm = (this as any);

      // TODO: Case on whether there's only 1 container here
      if (vm.containersWithTrips.length !== 1) {
        vm.lastOpenedContainerIdx = containerIdx;
        vm.$emit('showContainerDetails', containerIdx);
      }
    },
    toggleContainerHistory(containerIdx) {
      const vm = (this as any);

      vm.showTripForContainerIdx = -1;
      if (vm.showContainerHistoryIdx !== containerIdx) {
        vm.showContainerHistoryIdx = containerIdx;
      } else {
        vm.showContainerHistoryIdx = -1;
      }
    },
    addContainerNumber(container: Container) {
      const vm = (this as any);

      // @ts-ignore
      vm.isEditingContainerNumber = container.id;
      if (container.containerId !== 'EXPUNDEF') {
        vm.editingContainerNumber = container.containerId;
      }
    },
    cargoDescriptionString(container: Container): string {
      if (
        container.freightContents[0].cargoDescription &&
        container.referenceNumber
      ) {
        return `${container.freightContents[0].cargoDescription} / Ref # ${container.referenceNumber}`;
      } else if (container.freightContents[0].cargoDescription) {
        return container.freightContents[0].cargoDescription;
      } else if (container.referenceNumber) {
        return `Ref # ${container.referenceNumber}`;
      }
      return '';
    },
    cancelContainerNumberEdit() {
      const vm = (this as any);

      vm.isEditingContainerNumber = -1;
    },
    editWeight(containerIdx: any) {
      const vm = (this as any);

      vm.isEditingWeight = containerIdx;
    },
    cancelEditWeight(containerIdx: any) {
      (this as any).isEditingWeight = -1;
    },
    tripCompletionText(trips: any[]): string {
      const nTrips = trips.length;
      const completedTrips = trips.filter((x) => x.status === 'Complete');
      const inProgressTrips = trips.filter((x) => x.status === 'In Progress');

      if (inProgressTrips.length === 0 && completedTrips.length === 0) {
        return TRIP_STATUS.NOT_STARTED;
      } else if (completedTrips.length === nTrips) {
        return TRIP_STATUS.COMPLETE;
      } else {
        return TRIP_STATUS.IN_PROGRESS;
      }
    },
    saveWeight(id: string) {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: EditWeight,
          variables: {
            containerId: id,
            weight: vm.editingWeight,
          },
        })
        .then((data) => {
          vm.isEditingSealNumber = -1;
          vm.editingSealNumber = undefined;
          vm.editingWeight = undefined;
          vm.editingCargoPieces = undefined;
          vm.isEditingCargoDescription = -1;
          vm.isEditingCargoPieces = -1;
          vm.isEditingWeight = -1;
          vm.$emit('refreshOrders');
        })
        .catch((err) => {
          vm.isEditingSealNumber = -1;
          vm.editingSealNumber = undefined;
          vm.editingWeight = undefined;
          vm.editingCargoPieces = undefined;
          vm.isEditingCargoDescription = -1;
          vm.isEditingCargoPieces = -1;
          vm.isEditingWeight = -1;
        });
    },
    openCancelContainerModal(container: Container) {
      const vm = (this as any);
      vm.cancelContainerTarget = container;
      vm.isCancelContainerModalOpen = true;
    },
    closeCancelContainerModal() {
      const vm = (this as any);
      vm.isCancelContainerModalOpen = false;
      vm.cancelContainerTarget = null;
    },
    submitCancelContainer(cancelledReason: string) {
      const vm = (this as any);
      const container = vm.cancelContainerTarget;
      if (!container) return;

      vm.$apollo
        .mutate({
          mutation: CancelOrderContainerMutation,
          variables: {
            containerId: container.id,
            cancelledReason,
          },
        })
        .then(() => {
          pushToast(`Cancelled container ${container.containerId}`, 'success', 4000);
          vm.closeCancelContainerModal();
          vm.$emit('refreshOrders');
        })
        .catch((err: Error) => {
          console.error(err);
          pushToast(err.message || 'Could not cancel container', 'error', 5000);
        });
    },
    uncancelContainer(container: Container) {
      const vm = (this as any);
      vm.$apollo
        .mutate({
          mutation: UncancelOrderContainerMutation,
          variables: { containerId: container.id },
        })
        .then(() => {
          pushToast(`Restored container ${container.containerId}`, 'success', 4000);
          vm.$emit('refreshOrders');
        })
        .catch((err: Error) => {
          console.error(err);
          pushToast(err.message || 'Could not restore container', 'error', 5000);
        });
    },
    addEmptyTrip(order: any, container: any) {
      const vm = (this as any);

      if (container.isCancelled) {
        pushToast('Cancelled containers cannot have trips added', 'warning', 4000);
        return;
      }

      vm.$apollo
        .mutate({
          mutation: AddDefaultTripsMutation,
          variables: {
            containerId: container.id,
            orderId: order.id,
          },
        })
        .then((data) => {
          vm.tripAdditionContainer = undefined;
          vm.$emit('refreshOrders');
        })
        .catch((err) => {
          console.error(err);
          vm.tripAdditionContainer = undefined;
          vm.$emit('refreshOrders');
        });
    },
    saveContainerNumber(container: Container) {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: UpdateContainerNumber,
          variables: {
            id: container.id,
            containerNumber: vm.editingContainerNumber,
          },
        })
        .then(() => {
          vm.isEditingContainerNumber = -1;
          vm.editingContainerNumber = undefined;
          (this as any).$emit('refreshOrders');
        })
        .catch((err) => {
          console.error(err);
        });
    },
    saveTripChassis(trip: any) {
      const vm = (this as any);
      
      (this as any).$apollo
        .mutate({
          mutation: EditTripChassis,
          variables: {
            tripId: Number(trip.id),
            chassis: (this as any).editingTrip.chassis,
          },
        })
        .then(() => {
          (this as any).$emit('refreshOrders');
          (this as any).editingTrip.id = undefined;
          (this as any).editingTrip.chassis = undefined;
        });
    },
    editTripDriver(trip: any) {
      (this as any).editingTrip.id = trip.id;
      (this as any).editingTrip.isEditingDriver = true;
    },
    editTripChassis(trip: any) {
      (this as any).editingTrip.id = trip.id;
      (this as any).editingTrip.isEditingChassis = true;
    },

    editTripOrigin(trip: any) {
      (this as any).editingTrip.id = trip.id;
      (this as any).editingTrip.isEditingOrigin = true;
    },
    editTripDestination(trip: any) {
      (this as any).editingTrip.id = trip.id;
      (this as any).editingTrip.isEditingDestination = true;
    },
  },

  computed: {
    baseLoadText(): string {
      if ((this as any).isLandOrder((this as any).order)) {
        return 'Load';
      } else {
        return 'Container';
      }
    },
    shouldShowContainerInfo(): boolean {
      const vm = (this as any);

      return !vm.isLandOrder(vm.order);
    },
    shouldShowYardStatus(): boolean {
      const vm = (this as any);

      return vm.order.orderType === 'Import';
    },
    shouldShowPickUpNumber(): boolean {
      const vm = (this as any);

      return vm.order.orderType === 'RailPickUp';
    },
    shouldShowReleaseNumber(): boolean {
      const vm = (this as any);

      return vm.order.orderType === 'RailDelivery';
    },
    shouldShowEtaOrLfd(): boolean {
      const vm = (this as any);

      return vm.order.orderType === 'Import';
    },
    isContainerAdditionNumberInvalid(): boolean {
      const vm = (this as any);

      if (
        !vm.containerAddition.containerId ||
        vm.containerAddition.containerId.length < 11
      ) {
        return true;
      } else {
        return isContainer(vm.containerAddition.containerId);
      }
    },
    isContainerEditingNumberInvalid(): boolean {
      const vm = (this as any);

      if (
        !vm.editingContainerNumber ||
        vm.editingContainerNumber.length !== 11
      ) {
        return true;
      } else {
        return !isContainer(vm.editingContainerNumber);
      }
    },
  },
  ...{
    apollo: {},
  },
});
</script>

<style lang="scss" scoped>
/* make table rows mouse cursor "zoom in" to imply "click to view details" */
table tr.container-item-row td {
  cursor: zoom-in;
}
.trip-card {
  border: 1px solid black;
}

.uk-badge {
  // display: inline-block !important;
  text-align: center !important;
  // height: none !important;
}

.tall-row {
  height: 80px;
  background-color: #ccdfe5 !important;
}

.no-hover:hover {
  background: #ffffff;
}
</style>
